import helloName from './taskRepository.vue'
export default helloName


// WEBPACK FOOTER //
// ./src/index.js